import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface OptionCardProps {
  label: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
}

export default function OptionCard({
  label, description, selected, onSelect,
}: OptionCardProps) {
  return (
    <button
      type="button"
      className={`register-option-card${selected ? ' selected' : ''}`}
      onClick={onSelect}
    >
      <span className="register-option-card-text">
        <span className="register-option-card-label">{label}</span>
        <span className="register-option-card-description">{description}</span>
      </span>
      <span className="register-option-card-radio">
        {selected && <Icon iconType="checkmark" color={cssVar('text-on-accent')} size="small" />}
      </span>
    </button>
  );
}
